import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { auth as AuthGen } from '@valvur/shared-grpc';
import { lastValueFrom, take } from 'rxjs';
import { environment } from '../../../../environments/environment';

export type ParentKidPatrolDashboardView = AuthGen.KidPatrolDashboardView & {
  roblox?: AuthGen.DossierRobloxActivity;
};

@Injectable({ providedIn: 'root' })
export class ParentPatrolService {
  #http = inject(HttpClient);

  getKidPatrol(kidId: string): Promise<ParentKidPatrolDashboardView> {
    return lastValueFrom(
      this.#http
        .get<ParentKidPatrolDashboardView>(
          `${environment.baseUrl}/user/parent/children/${encodeURIComponent(kidId)}/patrol`,
        )
        .pipe(take(1)),
    );
  }
}
